export const USER_AUTH_SUCCESS = '@@user/USER_AUTH_SUCCESS';
export const USER_REFRESH_SUCCESS = '@@user/USER_REFRESH_SUCCESS';
export const USER_AUTH_ERROR = '@@user/USER_AUTH_ERROR';
export const USER_AUTH_LOADING = '@@user/USER_AUTH_LOADING';
export const USER_AUTH_LOGOUT = '@@user/USER_AUTH_LOGOUT';
export const USER_AUTH_LOGOUT_CREDENTIALS = '@@user/USER_AUTH_LOGOUT_CREDENTIALS';
export const USER_AUTH_UNAUTHORIZED = '@@user/USER_AUTH_UNAUTHORIZED';

export const USER_SUPER_ADMIN_AUTH_SUCCESS = '@@user/USER_SUPER_ADMIN_AUTH_SUCCESS';
